import { Country } from "./interfaces";

// export const BRAINTREE_TOKEN = 'sandbox_ksb5t7mt_yzst3vvrqffrw84x';
export const BRAINTREE_TOKEN = 'production_h7np492v_y3c3xj68qs2dvngy';

export const HARDCOPY_PRODUCT_NAME = 'Ireland - A Directory 2020';

export const HARDCOPY_MAX_QTY = 99;
export const HARDCOPY_MIN_QTY = 1;
export const HARDCOPY_PRICE = 70.00;

export const HARDCOPY_COUNTRIES: Country[] = [{
    id: 'IRL',
    abbr: 'IRL',
    name: 'Ireland',
    postage: 0,
    postcode: 'Eircode',
}, {
    id: 'GBR',
    abbr: 'UK',
    name: 'United Kingdom',
    postage: 7.00,
    postcode: 'Postcode',
}]

export const HARDCOPY_DEFAULT_COUNTRY = 'IRL';



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/settings.ts